import { HHBox, HHTypography } from '@hinge-health/react-component-library';
import { tagsTabContent } from '../constants/tags.constant';

export const NoTagsMessage = (): JSX.Element => (
  <HHBox textAlign="center">
    <HHTypography hhVariant="h3">{tagsTabContent.noTags.title}</HHTypography>
    <HHTypography hhVariant="body">{tagsTabContent.noTags.body}</HHTypography>
  </HHBox>
);
